import Vue from 'vue';
import App from './App.vue';

import router from './router';
import store from './store';

import config from './config.js'
import {RE} from '@/config.js'
import library from '@deanwu/vue-component-library'
import '@deanwu/vue-component-library/dist/vue-component-library.css'
Vue.use(library, config);

import comps from './components/index.js'
Vue.use(comps);
import dialog from './components/dialog.js'
Vue.use(dialog);
import print from '@/components/public/print.js'
Vue.use(print);

import 'jodit/build/jodit.min.css'
import JoditVue from 'jodit-vue'
Vue.use(JoditVue)

Vue.prototype.RE = RE;

Vue.prototype.$bus = new Vue();

Vue.prototype.lock = function(val) {
	return val && this.$store.getters.freeEdition && !this.$store.getters.freeAuthKey.includes(val);
}

// 获取APP.vue实例
Vue.prototype.getApp = function() {
	return app.$children[0];
};

// 获取pages/index.vue实例
Vue.prototype.getSys = function() {
	return app.$children[0].$children.find(item => item.$options.name == 'Sys');
};

Vue.prototype.uploadConfig = function(opt) {
	window._uploadConfig = Object.assign(opt, window._uploadConfig);
}

Vue.prototype.oss = function(url, w) {
	if (!url || !url.includes('?auth_key')) return url;
	return `${url}&image_process=resize,l_${w}`;
};

Vue.prototype.$print = function(url) {
	app.getApp().print(url);
};

Vue.prototype.getSignPath = async function(opt) {
	let {data: signature} = await app.request({
		url: '/oss/weboffice/getPreViewUrl',
		data: {
			file_paths: Array.isArray(opt.src) ? opt.src : [opt.src],
			urlType: 0
		},
		loading: true
	});
	signature = Array.isArray(opt.src) ? signature.urls : signature.urls[0];
	opt.success && opt.success(signature);
	return signature;
};

Vue.prototype.getRealPath = function(path) {
	return path.includes('?auth_key') ? decodeURIComponent(path.replace(/\?auth_key.+/, '')) : path;
};

Vue.prototype.download = function(opt) {
	if (opt.signFree) {
		this.request({
			method: 'get',
			url: opt.url,
			responseType: 'blob',
			loading: opt.loading || true,
			success: res => {
				const blob = new Blob([res.data], {type: res.data.type});
				const link = document.createElement('a');
				link.href = window.URL.createObjectURL(blob);
				link.download = opt.fileName || '未命名文件';
				link.click();
				window.URL.revokeObjectURL(link.href);
			}
		});
	} else {
		this.request({
			url: '/oss/weboffice/getPreViewUrl',
			data: {
				filepath: opt.url,
				urlType: 1
			},
			loading: true,
			success: data => {
				let a = document.createElement('a');
				a.style.display = 'none';
				a.href = data;
				document.body.appendChild(a);
				a.click();
				document.body.removeChild(a);
			}
		})
	}
};

Vue.prototype.dialogFormEditConfirm = function($form, events) {
	if ($form && $form.editState) {
		events[0]();
		this.$confirm({
			message: '关闭后已更改的数据将会丢失，确定要关闭吗？',
			cancelButtonName: '继续编辑',
			resolve: () => {
				$form.setEditState && $form.setEditState(false);
				events[1]();
			}
		})
	}
};

Vue.prototype.freeEditionTips = function(route) {
	this.$confirm({
		zIndex: 9999,
		type: 'warn',
		title: '功能暂不可用',
		message: '此功能为<b style="color: #9F5A16;">【专业版】</b>功能，请开通专业版后使用',
		buttonName: '开通专业版',
		resolve: () => {
			this.navigateTo('/upgrade');
		},
		cancel: () => {
			route && this.navigateTo('/');
		}
	})
};

Vue.prototype.checkDataCount = function(code, id) {
	return this.request({
		url: '/system/verifiedCount',
		data: {
			work_code: code,
			work_type_id: id
		},
		loading: true,
		success: (data, msg) => {
			if (!data) {
				let type = this.$store.getters.freeEdition ? 'free' : 'vip';
				// let limit = code == 'SYSTEM_USER' ? this.$store.state.saasInfo.max_account_count : this.$store.state.systemConfig[{
				// 	SYSTEM_VIEW: `${type}_view_count`,
				// 	PRODUCT: `${type}_product_count`,
				// 	PROCESS: `${type}_process_count`,
				// 	WAREHOUSE: `${type}_warehouse_count`,
				// 	SALARY_MATCH_CONFIG: `${type}_salary_match_count`,
				// 	SYSTEM_FIELD: `${type}_field_count`
				// }[code]];
				
				if (this.$store.getters.freeEdition) {
					this.$confirm({
						type: 'warn',
						title: '数据条数已达上限',
						message: msg,
						buttonName: '开通专业版',
						resolve: () => {
							this.navigateTo('/upgrade');
						}
					});
				} else {
					this.$confirm({
						type: 'warn',
						title: '数据条数已达上限',
						message: msg,
						buttonName: '我知道了',
						cancelButton: false
					});
				}
			}
		}
	});
};

Vue.prototype.scanCode = function(opt) {
	opt = Object.assign({
		parse: true
	}, opt);
	
	app.getApp().registerScanEvent(text => {
		if (opt.parse) {
			try {
				let search;
				if (/http(s)?:/.test(text)) {
					search = new URL(text).search;
				} else {
					search = text;
				}
				let data = {};
				new URLSearchParams(search).forEach((value, key) => {
					data[key] = value;
				});
				opt.success(data);
			} catch(e) {
				console.error(e);
				this.$message({
					message: '二维码内容解析失败'
				});
			}
		} else {
			opt.success(text.replace(text.match(/^[A-Z]+_[A-Z\d]+,/), ''));
		}
	});
};

const vmLockHandle = function(el, lock) {
	let vm = el.__vue__;
	if (!vm) return;
	let box = vm.$options.name == 'cButton' ? el.childNodes[0] : el;
	let vip = box.querySelector('.vip');
	if (lock) {
		if (!el._lockInterceptor) {
			el._lockInterceptor = (e) => {
				e.stopImmediatePropagation();
				e.preventDefault();
				vm.freeEditionTips();
			};
			el.addEventListener('click', el._lockInterceptor, true);
		}

		if (!vip) {
			vip = new Image();
			vip.src = require('@/assets/image/vip.png');
			vip.className = 'vip';
			vip.style.height = '14px';
			vip.style.marginLeft = '4px';
			vip.style.marginBottom = '1px';
			box.appendChild(vip);
		}
	} else {
		vip && box.removeChild(vip);
		el.removeEventListener('click', el._lockInterceptor, true);
		delete el._lockInterceptor;
	}
}

Vue.directive('lock', {
	inserted(el, {value: lock}) {
		let vm = el.__vue__;
		if (lock && vm && vm.$options.name == 'cTableButton') {
			vm.$off('click');
			vm.$on('click', () => {
				vm.freeEditionTips();
			});

			setTimeout(() => {
				let group = el.parentNode.parentNode;
				let more = group.__vue__ ? group.__vue__.$refs.list : null;
				let node = group.querySelector(`[title='${el.innerText}']`) || (more ? more.querySelector(`[title='${el.innerText}']`) : null);
				if (node) {
					let vip = new Image();
					vip.src = require('@/assets/image/vip.png');
					vip.style.height = '14px';
					vip.style.marginLeft = '2px';
					vip.style.marginBottom = '2px';
					node.appendChild(vip);
				}
			}, 100);
		} else {
			vmLockHandle(el, lock);
		}
	},

	update(el, {value: lock}) {
		let vm = el.__vue__;
		vmLockHandle(el, lock);
	}
});

Vue.directive('paste', {
	bind(el, {value: push}) {
		let pasteParseHandle = null;
		['.c-input input', '.c-input textarea', '.c-datetime input'].forEach(selector => {
			$(el).on('focus', selector, function() {
				pasteParseHandle = async e => {
					let paste = e.clipboardData.getData('text/html').match(/<td[^>]*>(?:(?!<\/tb>).)*<\/td>/g);
					if (!paste) return;
					e.preventDefault();
					let colIndex = $(this).closest('td').index();
					let $row = $(this).closest('tr').nextAll('tr');
					if (push && paste.length - 1 > $row.length) {
						for (let i = $row.length; i < paste.length - 1; i++) {
							await push();
						}
						$row = $(this).closest('tr').nextAll('tr');
					}
					paste.forEach((item, index) => {
						let input = index ? $row.eq(index - 1).find('td').eq(colIndex).find(selector).get(0) : this;
						if (input) {
							try {
								input.value = item.match(/<td[^>]*>((?:(?!<\/tb>).)*)<\/td>/)[1].replaceAll('<br>', '\n').replace(/<[^>]*>/g, '').trim();
								input.dispatchEvent(new Event('input', {bubbles: true}));
								input.dispatchEvent(new Event('change', {bubbles: true}));
							} catch(e) {}
						}
					});
				};
				document.addEventListener('paste', pasteParseHandle);
			});
			$(el).on('blur', selector, function() {
				document.removeEventListener('paste', pasteParseHandle);
				pasteParseHandle = null;
			});
		});
	}
});

Vue.directive('scan', {
	bind(el, {value: callback}) {
		el.__vue__._scanCallback = callback;
		app.getApp().registerScanInput(el);
	}
});

Vue.prototype.window = window;

Vue.config.productionTip = false;

const app = window.$app = new Vue({
	router,
	store,
	render: (h) => h(App),
}).$mount('#app');
